import clsx from 'clsx';
import React from 'react';
import './POSLogo.less';

export type POSLogoProps = {
  className?: string;
  inverted?: boolean;
  color: 'default' | 'colored' | 'gold';
  hideLetters?: boolean;
};

export const POSLogo = ({
  className,
  inverted,
  hideLetters,
  color = 'default',
}: POSLogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('pos-logo', className, inverted && 'inverted', color)}
      width="60"
      height="60.168"
      viewBox="0 0 60 60.168"
    >
      <path
        className="ring-a"
        d="M1990.347,1056.1a18.282,18.282,0,0,1-9.931,8.644c-.532.2-1.068.365-1.606.51a20.864,20.864,0,0,1-4.264,2.081,20.051,20.051,0,0,0,6.37-1.234,19.686,19.686,0,0,0,11.81-11.808A19.793,19.793,0,0,1,1990.347,1056.1Z"
        transform="translate(-1940.194 -1008.359)"
      />
      <path
        className="ring-a"
        d="M1696.793,824.6a16.708,16.708,0,0,1-2.4-13.365,17.2,17.2,0,0,1,.68-2.2,22.694,22.694,0,0,1,1.187-5.076,18.462,18.462,0,0,0,.579,23.077A19.913,19.913,0,0,1,1696.793,824.6Z"
        transform="translate(-1692.484 -788.513)"
      />
      <path
        className="ring-b"
        d="M2028.924,713.676q1.459.579,2.9,1.186a19.466,19.466,0,0,1,11.39,13.354,20,20,0,0,1,.592,4.72,19.587,19.587,0,0,1,.6,5.984,21.171,21.171,0,0,0-12.018-25.39q-3.226-1.366-6.533-2.57c.413.318.816.651,1.208,1Q2028,712.808,2028.924,713.676Z"
        transform="translate(-1985.256 -706.836)"
      />
      <path
        className="ring-b"
        d="M1712.615,699.753a23.186,23.186,0,0,0,.248,6.933c.453,2.415.979,4.891,1.567,7.407.063-.6.152-1.205.27-1.809.124-.634.254-1.261.383-1.888q-.429-2.012-.8-3.977a21.5,21.5,0,0,1,13.565-24.1,19.929,19.929,0,0,1,5.491-2.409q.888-.239,1.783-.393a22.87,22.87,0,0,0-22.509,20.231Z"
        transform="translate(-1710.03 -679.227)"
      />
      <path
        className="ring-b"
        d="M1798.018,1092.3a21.5,21.5,0,0,0,3.794-3.07q1.992-2.029,3.947-4.141-1.641.708-3.293,1.388-.84.876-1.686,1.738a19.467,19.467,0,0,1-13.956,5.9,20.039,20.039,0,0,1-4.909-.615,19.82,19.82,0,0,1-7.022-3.328,20.308,20.308,0,0,1-6.211-4.729,20.942,20.942,0,0,0,12.879,9.46,21.5,21.5,0,0,0,5.269.661,20.778,20.778,0,0,0,11.188-3.268Z"
        transform="translate(-1759.402 -1035.398)"
      />
      <path
        className="ring-c"
        d="M1781.972,703.2a19.759,19.759,0,0,0-3.97-7.688,130.813,130.813,0,0,0-10.915-11.572q-.922-.866-1.858-1.712c-.391-.353-.8-.686-1.208-1a19.8,19.8,0,0,0-15.507-3.829q-.895.156-1.784.393a19.8,19.8,0,0,0-13.738,13.082,167.86,167.86,0,0,0-4.519,17.4c-.129.627-.259,1.254-.383,1.888-.118.6-.207,1.207-.27,1.809q-.064.613-.09,1.223a19.915,19.915,0,0,0,.042,2.438,19.57,19.57,0,0,0,4.929,11.519,20.44,20.44,0,0,0,1.747,1.74,20.2,20.2,0,0,0,4.464,2.989,19.557,19.557,0,0,0,8.625,2,20.141,20.141,0,0,0,6.336-1.031c4.208-1.393,8.433-2.958,12.612-4.671q1.653-.678,3.293-1.388c.3-.131.608-.26.911-.392a20.189,20.189,0,0,0,2.885-1.551,19.643,19.643,0,0,0,8.486-12.091,20.212,20.212,0,0,0,.513-3.57A19.588,19.588,0,0,0,1781.972,703.2Zm-11.862,21.872h0c-5.492,2.4-11.108,4.556-16.691,6.4a18.436,18.436,0,0,1-23.908-21.038,169.034,169.034,0,0,1,4.859-19.124,18.33,18.33,0,0,1,12.737-12.128,18.4,18.4,0,0,1,17.154,4.117,129.138,129.138,0,0,1,12.63,13.136,18.41,18.41,0,0,1-6.781,28.633Z"
        transform="translate(-1723.421 -677.098)"
      />
      {!hideLetters && (
        <>
          <path
            className="letters"
            d="M1801.128,852.636a10.078,10.078,0,1,0,10,10.093A10.029,10.029,0,0,0,1801.128,852.636Zm0,16.389a6.32,6.32,0,1,1,6-6.3A6.152,6.152,0,0,1,1801.128,869.025Z"
            transform="translate(-1779.139 -831.257)"
          />
          <path
            className="letters"
            d="M1983.924,866.8c0-6.778-10.153-5.242-10.153-8.676,0-1.145,1.055-1.928,2.862-1.928a5.625,5.625,0,0,1,4.519,2.259l2.591-2.561a8.334,8.334,0,0,0-6.959-3.254c-4.127,0-7.05,2.32-7.05,5.6,0,6.718,10.153,5.031,10.153,8.767,0,1.386-1.175,2.229-3.284,2.229a5.9,5.9,0,0,1-4.91-2.41l-2.681,2.5c1.265,1.9,3.585,3.465,7.532,3.465C1980.972,872.791,1983.924,870.29,1983.924,866.8Z"
            transform="translate(-1935.334 -831.257)"
          />
        </>
      )}
    </svg>
  );
};
